import {
  TokenList,
  GetTokenListParams,
  GetQuoteParams,
  GetSwapTxParams,
  GetApprovalTxParams,
  GetAllowanceParams,
  Quote,
  SwapTx,
  ApprovalTx,
  Allowance,
} from "@cede/types";

export type ApiUrl = string;
export type GetTokenList = (params: GetTokenListParams) => Promise<TokenList>;
export type GetQuote = (params: GetQuoteParams) => Promise<Quote>;
export type GetSwapTx = (params: GetSwapTxParams) => Promise<SwapTx>;
export type GetApprovalTx = (params: GetApprovalTxParams) => Promise<ApprovalTx>;
export type GetAllowance = (params: GetAllowanceParams) => Promise<Allowance>;
